// extracted by mini-css-extract-plugin
export var dropdownButton = "_49-0";
export var fullWidthDropdownButton = "_49-1";
export var icon = "_49-3";
export var iconPlaceholder = "_49-2";
export var menuItemRow = "_49-8";
export var separator = "_49-c";
export var shortcutContainer = "_49-7";
export var shortcutIconLg = "_49-6";
export var shortcutIconMd = "_49-5";
export var shortcutIconSm = "_49-4";
export var submenuChevron = "_49-b";
export var submenuDropdown = "_49-9";
export var submenuTriggerRow = "_49-a";